var map = {
	"./AIR QUALITY.png": 9140,
	"./AIR TEMPERATURE.png": 3387,
	"./AIRQUALITY.png": 4539,
	"./AIRTEMPERATURE.png": 8490,
	"./HUMIDITY.png": 7250,
	"./LIGHT INTENSITY.png": 8298,
	"./LIGHTS.png": 3104,
	"./LevelView.png": 590,
	"./SOIL MOISTURE.png": 7352,
	"./SOIL pH.png": 8507,
	"./SOILMOISTURE.png": 3750,
	"./SOILpH.png": 9896,
	"./arrow.png": 9765,
	"./bars.png": 4511,
	"./blueairquality.png": 4214,
	"./blueairtemperature.png": 8876,
	"./bluehumidity.png": 7702,
	"./blueoverallstatus.png": 2398,
	"./bluesoilmoisture.png": 8354,
	"./bluesoilph.png": 5211,
	"./camera.png": 1815,
	"./equalizer.png": 5006,
	"./greenstatus.png": 8779,
	"./greycamera.png": 2239,
	"./greyplant.png": 9919,
	"./greystatus.png": 9070,
	"./harvest.png": 464,
	"./placeholder.png": 3914,
	"./plant.png": 8889,
	"./settings.png": 3424,
	"./wall.png": 4337,
	"./whitecamera.png": 9389,
	"./whiteequalizer.png": 4857,
	"./whiteharvest.png": 7331,
	"./whiteplant.png": 1180,
	"./whitesettings.png": 82,
	"./whitestatus.png": 4562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;